import './title.css';

interface TitleProps {
    text?: string | undefined;
    size?: 'xs' | 's' | 'm' | 'l' | 'xl' | 'xxl' | 'hero';
    color?: 'green' | 'red' | 'black' | 'white' | 'secondary-text';
    weight?: 'regular' | 'semi' | 'bold';
    customisation?: string;
    children?: React.ReactNode;
}

const Title: React.FC<TitleProps> = ({
    text,
    size = 'm',
    color = 'black',
    weight = 'bold',
    customisation = '',
    children,
}) => {
    return (
        <h1 className={`title ${color} ${size} ${weight} ${customisation}`}>
            {text || children}
        </h1>
    );
};

export default Title;
